import { AfterViewChecked, Component, ElementRef, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-example-monouse-component",
  template: ``,
  styles: [],
  standalone: false,
})
export class FixRequestAmmissibilityComponent implements AfterViewChecked {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngAfterViewChecked(): void {
      this.fatherContaierRef.dataTable.map((res: any) => {
        if (res.companyInfo.includes('Azienda:')) {
          res.companyName = (res.companyInfo.replace('Azienda: ', '')).split('\n')[0]
        }
        return res
      });
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
